<template>
  <div class="printme">
    <div class="visibility-hidden">
      <b-row>
        <b-col cols="4">
          <img
            src="../../assets/logo-promart.png"
            style="height: 80px; width: auto"
            alt=""
          />
        </b-col>
        <b-col cols="4">
          <p class="font-weight-500" style="margin-bottom: 0;margin-top:8%">
            INFORME TÉCNICO
          </p>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col cols="6">
        <b-form-group id="input-group-17" label="Cliente" label-for="input-17">
          <b-form-input
            :disabled="enableEdit"
            id="input-17"
            v-model="informTech.clientName"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="input-group-19" label="Tienda" label-for="input-19">
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.codeStore"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-form-group id="input-group-19" label="N° OS" label-for="input-19">
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.numberOs"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group
          id="input-group-19"
          label="Fecha de Servicio"
          label-for="input-19"
        >
          <b-form-input
            readonly
            id="input-17"
            v-model="informTech.dateService"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col cols="6">
        <b-form-group
          id="input-group-50"
          label="Nombre de Técnico"
          label-for="input-19"
        >
          <b-form-input
            :disabled="enableEdit"
            id="input-50"
            v-model="informTech.technicianName"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group id="input-group-50" label="Estado" label-for="input-19">
          <b-form-input
            readonly
            id="input-50"
            v-model="informTech.state"
            required
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="padding-two-bottom">
        <label>Reporte de cliente</label>
        <b-form-textarea
          :disabled="enableEdit"
          v-model="informTech.report"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          class="
                        text-medium
                        padding-two-bottom
                      "
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col cols="12" class="padding-two-bottom">
        <b-form-group
          id="input-group-4"
          label="Diagnóstico"
          label-for="input-4"
        >
          <b-form-select
            :disabled="enableEdit"
            id="input-4"
            v-model="informTech.diagnostic"
            :options="options"
            required
          >
            <template #first>
              <b-form-select-option :value="null" disabled
                >Seleccione uno</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="padding-two-bottom">
        <label>Informe</label>
        <b-form-textarea
          :disabled="enableEdit"
          v-model="informTech.technicalReport"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          class="
                        text-medium
                        padding-two-bottom
                      "
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="padding-two-bottom">
        <label>Recomendaciones</label>
        <b-form-textarea
          :disabled="enableEdit"
          v-model="informTech.recommendations"
          id="textarea-large"
          size="lg"
          rows="3"
          placeholder="Escriba aquí .."
          class="
                        text-medium
                        padding-two-bottom
                      "
        ></b-form-textarea>
      </b-col>
    </b-row>
    <b-row class="no-printme">
      <b-col cols="12" style="text-align:-webkit-center">
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="4000"
          controls
          indicators
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="text-shadow: 1px 1px 2px #333;"
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <!-- Text slides with image -->

          <div v-for="(photo, index) in photosRoute" :key="index">
            <b-carousel-slide :img-src="photo.photoUrl"> </b-carousel-slide>
          </div>
          <!-- Slides with custom text -->
        </b-carousel>
      </b-col>
    </b-row>
    <b-row class="no-printme padding-three-top" >
      <b-col cols="12" md="4" class="text-right" v-if="profileUser">
        <slot name="button-print-vi"> </slot>
      </b-col>
      <b-col cols="12" md="4" class="text-center" >
        <b-button
          :disabled="isEnableSave"
          @click="editInform"
          class="bg-purple btn-grey"
        >
          <font-awesome-icon icon="trash" /> GUARDAR
        </b-button>
      </b-col>
      <b-col cols="12" md="4" class="text-left">
        <b-button
          :disabled="enableApprove"
          @click="approveReport"
          class="btn-orange"
        >
          <font-awesome-icon icon="check-circle" /> APROBAR
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import {getPhotosRoute} from '../../assets/js/common'
import { mapState } from "vuex";
export default {
  name: "ReportTechVi",
  data() {
    return {
      photosRoute: [],
      slide: 0,
      sliding: null,
      currentPage: 1,
      perPage: 10,
      selectedOption: null,
      options: [
        { value: "MANIPULACION_CLIENTE", text: "MANIPULACION_CLIENTE" },
        { value: "PRODUCTO", text: "FALLA DE PRODUCTO" },
        { value: "MALA_INSTALACION", text: "MALA_INSTALACION" },
      ],
      fieldMaterial: [
        { key: "sku", label: "Sku" },
        { key: "description", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        { key: "typeProduct", label: "Tipo" },
        { key: "actions", label: "" },
      ],
      skuService: "",
      skuServiceDes: "",
      quantitySku: "",
      reportClient: "",
      inform: "",
      recomendation: "",
      informTech: {
        codeStore: "",
        dniClient: "",
        dniTechnical: "",
        numOs: "",
        observationsArea: "",
        detailServices: "",
        observationsAdditional: "",
        dateService: "",
        id: "",
        serviceMaterial: [],
        specialJob: [],
        diagnostic:null
      },
    };
  },
  props: ["idInspectionReport"],
  created() {
    this.getInformTech();
  },
  computed: {
    ...mapState("module", ["username", "perfil","token"]),
    profileUser() {
      let up = this.perfil.toUpperCase();
      if (up === "PROVEEDOR") return false;
      else return true;
    },
    isEnableSave(){
      let up = this.perfil.toUpperCase();
      if((up === "PROVEEDOR"||up === "ADMINISTRADOR") &&this.informTech.state == "PENDIENTE_APROBACION"){
        return false;
      }
      return true
    },
    enableApprove(){
      let up = this.perfil.toUpperCase();
      if((up === "PROVEEDOR"||up === "ADMINISTRADOR") &&this.informTech.state == "PENDIENTE_APROBACION"){
        return false;
      }
      return true
    },
    enableEdit() {
      if (this.informTech.state == "APROBADO") return true;
      return false;
    },
  },
  methods: {
    print() {
  window.print();
},
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    },
    deleteRow(item) {
      console.log(item);
      if (item.typeProduct == "SERVICIO") {
        let i = this.informTech.serviceMaterial.findIndex(
          (s) => s.id == item.id
        );
        this.informTech.serviceMaterial.splice(i, 1);
        //this.formProvider.capacities[i].deleted = true;
      }
    },
    addSkuService() {
      let type = this.selectedOption == "A" ? "SERVICIO" : "MATERIAL";
      this.informTech.serviceMaterial.push({
        description: this.skuServiceDes,
        quantity: this.quantitySku,
        sku: this.skuService,
        typeProduct: type,
        idTvr: this.idInspectionReport,
      });
      this.skuService = "";
      this.quantitySku = "";
      this.skuServiceDes = "";
    },
    addSpecialJob() {
      this.informTech.specialJob.push({
        quantity: this.quantitySku,
        sku: this.skuService,
        idTvr: this.idInspectionReport,
      });
      this.skuService = "";
      this.quantitySku = "";
      this.skuServiceDes = "";
    },
    searchSkuService() {
      clearTimeout(this.timeout);
      let self = this;
      this.timeout = setTimeout(function() {
        self.getSkuService();
      }, 3000);
    },
    async getSkuService() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_SERVICES_CORE_BASE +
            "/services/" +
            this.skuService,
            {
              headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer "+ this.token
              },
            }
        );
        console.log(response);
        this.skuServiceDes = response.data.description;
      } catch (error) {
        console.error(error);
      }
    },
    async approveReport() {
      try {
        this.informTech.state = "APROBADO";
        this.$store.commit("SET_LOADING", true);
        let response = await axios.put(
          process.env.VUE_APP_ORDERS_CORE_BASE +
            "/ivr/" +
            this.idInspectionReport,
          this.informTech,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
    async editInform() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.put(
          process.env.VUE_APP_ORDERS_CORE_BASE +
            "/ivr/" +
            this.idInspectionReport,
          this.informTech,
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },
   
    async getInformTech() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ORDERS_CORE_BASE +
            "/ivr/" +
            this.idInspectionReport
        );
        this.informTech = response.data;
        console.log(response.data.idRoute);
       this.photosRoute= await getPhotosRoute(response.data.idRoute);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style >
.btn-grey {
  border-radius: 20px !important;
}
.font-bolder {
  font-weight: bold;
  font-size: 23px;
  padding: 0;
  background: transparent;
  border-color: transparent;
}
@media print {
  .text-modal-informe-vins {
    visibility: hidden !important;
  }
   #modal-informe-vins___BV_modal_header_{
    visibility: hidden !important;
  }
  .no-printme {
    display: none;
  }
  .printme {
    display: block !important;
   
  }
  .visibility-hidden {
    display: block !important;
  }
  @page {
  size: A4 portrait;
  margin: 1cm;
}
}

 .carousel-item {
  width: 500px;
  height: 480px;
  margin-right: auto !important;
  margin-left: auto !important;
  float: none !important;
}
 .d-block {
  display: initial !important;
}
 .carousel-item img {
  height: 480px;
  width: auto !important;
}
.visibility-hidden {
  display: none;
}
</style>
